"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceCommaWithDot = void 0;
var replaceCommaWithDot = function (text) { return text && text.replace(',', '.'); };
exports.replaceCommaWithDot = replaceCommaWithDot;
